'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _get2 = require('lodash/get');

var _get3 = _interopRequireDefault(_get2);

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _desc, _value, _class2, _descriptor, _class3, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobxReact = require('mobx-react');

var _mobx = require('mobx');

var _classAutobindDecorator = require('class-autobind-decorator');

var _classAutobindDecorator2 = _interopRequireDefault(_classAutobindDecorator);

var _Button = require('react-bootstrap/lib/Button');

var _Button2 = _interopRequireDefault(_Button);

var _Col = require('react-bootstrap/lib/Col');

var _Col2 = _interopRequireDefault(_Col);

var _Row = require('react-bootstrap/lib/Row');

var _Row2 = _interopRequireDefault(_Row);

var _Well = require('react-bootstrap/lib/Well');

var _Well2 = _interopRequireDefault(_Well);

var _AppConstants = require('../../../constants/AppConstants');

var _AppConstants2 = _interopRequireDefault(_AppConstants);

var _utils = require('../../../utils');

var _util = require('../../../utils/util');

var _common = require('../../common');

var _ApplicationFields = require('./ApplicationFields');

var _ApplicationFields2 = _interopRequireDefault(_ApplicationFields);

var _ApplicationStatusActions = require('./ApplicationStatusActions');

var _ApplicationStatusActions2 = _interopRequireDefault(_ApplicationStatusActions);

var _FinalizeMedicalApplicationModal = require('./FinalizeMedicalApplicationModal');

var _FinalizeMedicalApplicationModal2 = _interopRequireDefault(_FinalizeMedicalApplicationModal);

var _applicationRenderUtils = require('./applicationRenderUtils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  Object.defineProperty(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var APPLICATION_MODELS = _AppConstants2.default.APPLICATION_MODELS;
var formatDate = _utils.FormattingUtils.formatDate,
    formatMoney = _utils.FormattingUtils.formatMoney;
var MedicalApplication = (_dec = (0, _mobxReact.inject)('ApplicationStore', 'FunderStore'), _dec(_class = (0, _classAutobindDecorator2.default)(_class = (0, _mobxReact.observer)(_class = (_class2 = (_temp2 = _class3 = function (_Component) {
  _inherits(MedicalApplication, _Component);

  function MedicalApplication() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, MedicalApplication);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MedicalApplication.__proto__ || Object.getPrototypeOf(MedicalApplication)).call.apply(_ref, [this].concat(args))), _this), _initDefineProp(_this, 'finalizeModalOpen', _descriptor, _this), _this.type = APPLICATION_MODELS.MEDICAL.model, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(MedicalApplication, [{
    key: 'onCheckboxChange',
    value: function onCheckboxChange(e) {
      var _e$target = e.target,
          name = _e$target.name,
          checked = _e$target.checked,
          _props = this.props,
          ApplicationStore = _props.ApplicationStore,
          application = _props.application;


      ApplicationStore.update({
        application: application,
        data: _defineProperty({}, name, checked),
        load: false,
        type: this.type
      });
    }
  }, {
    key: 'renderCheckbox',
    value: function renderCheckbox(fieldName, label) {
      var application = this.props.application;


      return _react2.default.createElement(
        _Col2.default,
        { key: fieldName + '-' + application.id, xs: 3 },
        _react2.default.createElement('input', {
          id: fieldName + '-' + application.id,
          name: fieldName,
          type: 'checkbox',
          checked: application[fieldName],
          onChange: this.onCheckboxChange
        }),
        _react2.default.createElement(
          'label',
          { htmlFor: fieldName + '-' + application.id },
          label
        )
      );
    }
  }, {
    key: 'renderCheckboxes',
    value: function renderCheckboxes() {
      return [this.renderCheckbox('is_treatment_scheduled', 'Treatment Scheduled'), this.renderCheckbox('is_claim_received', 'Claim Received')];
    }
  }, {
    key: 'renderDateRejected',
    value: function renderDateRejected() {
      var application = this.props.application;


      return _react2.default.createElement(
        _Col2.default,
        { xs: 6 },
        _react2.default.createElement(
          'span',
          { className: 'date' },
          'Rejected at: ',
          formatDate(application.date_rejected)
        )
      );
    }
  }, {
    key: 'showMedicalDetailModal',
    value: function showMedicalDetailModal() {
      var _props2 = this.props,
          application = _props2.application,
          renderMedicalDetailModal = _props2.renderMedicalDetailModal;


      renderMedicalDetailModal(application);
    }
  }, {
    key: 'onLienClick',
    value: function onLienClick(status, lienId, applicationId) {
      var application = this.props.application;

      if (status === 'finalize' && applicationId === application.id) {
        this.finalizeModalOpen = true;
      }
    }
  }, {
    key: 'closeFinalizeMedicalApplicationModal',
    value: function closeFinalizeMedicalApplicationModal() {
      this.finalizeModalOpen = false;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          _props3$FunderStore = _props3.FunderStore,
          isFinanceCustomer = _props3$FunderStore.isFinanceCustomer,
          isMedicalProvider = _props3$FunderStore.isMedicalProvider,
          lien = _props3.lien,
          application = _props3.application,
          _case = _props3._case,
          onCaseApplicationChanged = _props3.onCaseApplicationChanged,
          renderDeleteButton = _props3.renderDeleteButton,
          createdAt = formatDate(application.created_at),
          commonFields = [{
        fieldName: 'label',
        label: 'Label',
        value: (0, _get3.default)(lien, 'label')
      }, {
        fieldName: 'billing_amount',
        formatter: formatMoney,
        label: 'Billing Amt',
        value: (0, _get3.default)(lien, 'billing_amount')
      }, {
        fieldName: 'notes',
        label: 'Note',
        value: (0, _get3.default)(lien, 'notes')
      }],
          purchaseAmountField = {
        fieldName: 'purchase_amount',
        formatter: formatMoney,
        label: 'Purchase Amt',
        value: (0, _get3.default)(lien, 'purchase_amount')
      },
          openFields = [].concat(commonFields, _toConsumableArray((0, _util.insertIf)(!isMedicalProvider, purchaseAmountField)), [{
        fieldName: 'medical_facility',
        label: 'Medical Facility',
        value: (0, _get3.default)(lien, 'medical_facility.name')
      }, {
        fieldName: 'initial_service_date',
        formatter: formatDate,
        label: 'DOS',
        value: (0, _get3.default)(lien, 'initial_service_date')
      }, {
        fieldName: 'end_service_date',
        formatter: formatDate,
        label: 'DOS',
        value: (0, _get3.default)(lien, 'end_service_date')
      }], _toConsumableArray((0, _util.insertIf)(isFinanceCustomer, {
        application: application,
        Component: _applicationRenderUtils.InlineCheckboxField,
        fieldName: 'is_available_to_coop',
        label: 'Available to CoOp?'
      }))),
          rejectedFields = [].concat(commonFields, [{
        fieldName: 'rejected_reason',
        label: 'Rejected Reason',
        value: (0, _get3.default)(application, 'rejected_reason')
      }, {
        fieldName: 'medical_facility',
        label: 'Medical Facility',
        value: (0, _get3.default)(lien, 'medical_facility.name')
      }, {
        fieldName: 'rejected_note',
        label: 'Rejected Note',
        lineWrap: true,
        value: (0, _get3.default)(application, 'rejected_note')
      }]),
          fields = application.status === 'rejected' ? rejectedFields : openFields;


      return _react2.default.createElement(
        _Well2.default,
        { className: 'application condensed padding-content' },
        _react2.default.createElement(
          'div',
          { className: 'content' },
          _react2.default.createElement(
            'div',
            { className: 'title' },
            _react2.default.createElement(_common.Icon, { type: 'medkit' }),
            'Medical Funding',
            _react2.default.createElement(
              'span',
              { className: 'date' },
              'Created at: ',
              createdAt
            ),
            renderDeleteButton()
          ),
          _react2.default.createElement(_ApplicationFields2.default, {
            fields: fields
          })
        ),
        _react2.default.createElement('hr', null),
        _react2.default.createElement(
          'div',
          { className: 'content footer' },
          _react2.default.createElement(
            _Row2.default,
            { className: 'flex-align-center' },
            _react2.default.createElement(
              _Col2.default,
              { xs: 3 },
              _react2.default.createElement(_ApplicationStatusActions2.default, {
                application: application,
                applicationId: application.id,
                caseId: _case.id,
                is_open: application.is_open,
                lien: lien,
                onCaseApplicationChanged: onCaseApplicationChanged,
                onLienClick: this.onLienClick,
                status: application.status,
                type: this.type
              })
            ),
            application.status === 'rejected' ? this.renderDateRejected() : this.renderCheckboxes(),
            _react2.default.createElement(
              _Col2.default,
              { xs: 3, className: 'text-right' },
              _react2.default.createElement(
                _Button2.default,
                { bsStyle: 'link', onClick: this.showMedicalDetailModal },
                'Details ',
                _react2.default.createElement(_common.Icon, { type: 'angle-double-right' })
              )
            )
          )
        ),
        this.finalizeModalOpen && _react2.default.createElement(_FinalizeMedicalApplicationModal2.default, {
          caseId: _case.id,
          onClose: this.closeFinalizeMedicalApplicationModal,
          application: application,
          lien: lien
        })
      );
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return MedicalApplication;
}(_react.Component), _class3.propTypes = {
  _case: _propTypes2.default.object,
  application: _propTypes2.default.object,
  ApplicationStore: _propTypes2.default.object.isRequired,
  FunderStore: _propTypes2.default.object.isRequired,
  lien: _propTypes2.default.object,
  onCaseApplicationChanged: _propTypes2.default.func.isRequired,
  onLienClick: _propTypes2.default.func.isRequired,
  renderDeleteButton: _propTypes2.default.func.isRequired,
  renderMedicalDetailModal: _propTypes2.default.func.isRequired
}, _temp2), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'finalizeModalOpen', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
})), _class2)) || _class) || _class) || _class);
var _default = MedicalApplication;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(APPLICATION_MODELS, 'APPLICATION_MODELS', '/app/src/components/page-case/main-applications/MedicalApplication.js');
  reactHotLoader.register(formatDate, 'formatDate', '/app/src/components/page-case/main-applications/MedicalApplication.js');
  reactHotLoader.register(formatMoney, 'formatMoney', '/app/src/components/page-case/main-applications/MedicalApplication.js');
  reactHotLoader.register(MedicalApplication, 'MedicalApplication', '/app/src/components/page-case/main-applications/MedicalApplication.js');
  reactHotLoader.register(_default, 'default', '/app/src/components/page-case/main-applications/MedicalApplication.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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